import { validateAndRewriteCoreSymbol } from '@angular/compiler-cli/src/ngtsc/imports';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { OptionSet } from '../../../models/OptionSet';

@Component({
  selector: 'app-multi-select-search',
  templateUrl: './multi-select-search.component.html',
  styleUrls: ['./multi-select-search.component.scss']
})
export class MultiSelectSearchComponent implements OnInit {
  selectedItems = [];
  @Input() placeholder: string;

  constructor() { }
  dropdownSettings: IDropdownSettings = {
    idField: 'value',
    textField: 'viewValue',
    enableCheckAll: true,
    selectAllText: 'בחר הכל',
    unSelectAllText: 'בטל הכל',
    itemsShowLimit: 2,
    allowSearchFilter: true,
    searchPlaceholderText:'חפש'
  };
  isReadonly = false;

  @Input() boolean: boolean;
  booleanDropdownSettings: IDropdownSettings = {
    idField: 'value',
    textField: 'viewValue',
    itemsShowLimit: 1,
    singleSelection: true,
    closeDropDownOnSelection: true
  };

  ngOnInit(): void {
  }
  @Input() optionSetList: Array<OptionSet> = new Array<OptionSet>();
  @Output() optionsSelected = new EventEmitter<any>();
  onItemSelect(item: OptionSet) {
    this.optionsSelected.emit(this.selectedItems)
  }
  onSelectAll(items: any) {
    this.selectedItems = items;
    this.optionsSelected.emit(this.selectedItems)
  }
  onItemDeSelect(item: any) {
    this.optionsSelected.emit(this.selectedItems)
  }

  clearFilter(){
    this.selectedItems = [];
  }
}
